import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { InfoIcon, MaximizeIcon, MinimizeIcon } from 'lucide-react';
interface ConfidenceNotificationProps {
  uplift: number;
  confidence: number;
}
export const ConfidenceNotification: React.FC<ConfidenceNotificationProps> = ({
  uplift,
  confidence
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 1.5,
    duration: 0.5
  }} className="fixed bottom-6 right-6 z-50" data-id="element-361">
      <AnimatePresence mode="wait" data-id="element-362">
        {!isExpanded ? <motion.div key="collapsed" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} className="bg-[#FFFFFF] rounded-sm shadow-sm border border-[#E5E5E5] p-4 flex items-center space-x-3 cursor-pointer hover:bg-[#F9FAFB] transition-colors" onClick={() => setIsExpanded(true)} data-id="element-363">
            <InfoIcon className="h-5 w-5 text-[#C00000] flex-shrink-0" data-id="element-364" />
            <span className="text-sm font-semibold text-[#171717]" data-id="element-365">
              +{uplift}% Brand Lift
            </span>
            <MaximizeIcon className="h-4 w-4 text-[#AAAAAA] ml-2" data-id="element-366" />
          </motion.div> : <motion.div key="expanded" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} className="bg-[#FFFFFF] rounded-sm shadow-sm border border-[#E5E5E5] p-6 w-80" data-id="element-367">
            <div className="flex items-start justify-between mb-3" data-id="element-368">
              <div className="flex items-center space-x-3" data-id="element-369">
                <InfoIcon className="h-6 w-6 text-[#C00000] flex-shrink-0" data-id="element-370" />
                <h3 className="text-lg font-semibold text-[#171717]" data-id="element-371">
                  {confidence}% Confidence Level
                </h3>
              </div>
              <button onClick={() => setIsExpanded(false)} className="text-[#AAAAAA] hover:text-[#171717] transition-colors" data-id="element-372">
                <MinimizeIcon className="h-4 w-4" data-id="element-373" />
              </button>
            </div>
            <p className="text-sm text-[#000000] leading-relaxed" data-id="element-374">
              Results at this level indicate very strong statistical confidence
              in the findings. The campaign achieved a{' '}
              <span className="font-semibold text-[#C00000]" data-id="element-375">
                +{uplift}% brand lift
              </span>{' '}
              with high certainty.
            </p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
};